export default class RevolverSettings {
    public static isCountupPlayed: boolean = false;
    public static winCount: number = 0;
    public static resetTimer: NodeJS.Timer;
    public static lastWinTime: number = 0;

    public static retriggerPending: boolean = false;
}